module.exports = __webpack_public_path__ + "static/media/gallery.416d143b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/gallery.jpg
// module id = 1164
// module chunks = 0